/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-09-10 19:14:41
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2024-01-10 09:37:33
 * @FilePath: \vue-hepha-order\src\views\stock\queryConfig\QueryForm.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const ReissueQueryForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'0px',
    formData:{},
    formField:[
        {
            // name:'order.orderSource', // 订单名称
            key:'order_name',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'order.orderName',
        },
        {
            // name:'order.orderSource', // mes出库单号
            key:'swap_number',
            type:'input',
            width:'200px',
            allowClear:true,
            placeholder:'stock.reissueNumber',
        },
        {
            // name:'order.deliverStatus', // 出库状态
            key:'status',
            type:'select',
            allowClear:true,
            width:'200px',
            optionToLocale:true,
            placeholder:'stock.reissueStatus',
            options:[
                {
                    value:1,
                    label:'order.replenishing'
                },
                {
                    value:4,
                    label:'stock.outScanned'
                },
                {
                    value:2,
                    label:'order.reissueSuccessful'
                },
                {
                    value:3,
                    label:'stock.cancelReissue2'
                },
            ]
        },
        {
            // name:'order.orderSource', // sku
            key:'swap_sku',
            type:'select',
            width:'200px',
            allowClear:true,
            placeholder:'order.sku',
            options:[],
        },
        {
            // name:'order.erpNo', // SO
            key:'erp_no',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.erpNo',
        },
        {
            // name:'order.customerType', // 仓库
            key:'swap_inventory',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.warehouse',
            options:[]
        },
        // {
        //     // name:'order.customerType', // 物流公司
        //     key:'swap_courier_type',
        //     type:'select',
        //     allowClear:true,
        //     width:'260px',
        //     optionToLocale:true,
        //     placeholder:'order.courierType',
        //     options:[]
        // },
        
        {
            // name:'order.customerType', // 客户
            key:'customer_id',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.customerName',
            options:[]
        },
        {
            // name:'order.customerType', // 创建人
            key:'create_by',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'order.createUser',
            options:[]
        },
        {
            // name:'order.customerType', // 物料类别
            key:'category_code',
            type:'select',
            allowClear:true,
            width:'200px',
            placeholder:'stock.categoryType',
            options:[]
        },
        {
            // name:'order.customerType', // 备注
            key:'instruction',
            type:'input',
            allowClear:true,
            width:'200px',
            placeholder:'order.instruction',
        },
        {
            name:'', // 换货计划发出时间
            key:'swap_timestamp_plan',
            type:'dateRange',
            allowClear:true,
            width:'310px',
            placeholder1:'stock.planShipStartDate',
            placeholder2:'stock.planShipEndDate',
        },
        {
            name:'', // 换货实际发出时间
            key:'swap_timestamp_real',
            type:'dateRange',
            allowClear:true,
            width:'310px',
            placeholder1:'stock.realShipStartDate',
            placeholder2:'stock.realShipEndDate',
        },
    ]
}

const ReissueEditForm = {
    layout:'inline',
    labelColProps: { span: 1 },
    wrapperColProps: { span: 3 },
    labelAlign:'right',
    labelColStyle:'130px',
    showSlot:true,
    formData:{},
    formField:[
        {
            name:'order.courierType', // 物流公司
            key:'swap_courier_type',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            options:[]
        },
        {
            name:'order.courierNo', // 物流单号
            key:'swap_courier_no',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierLink', // 物流链接
            key:'swap_courier_url',
            type:'input',
            allowClear:true,
            disabled:false,
            width:'260px',
        },
        {
            name:'order.courierStatus', // 物流状态
            key:'swap_courier_status',
            type:'select',
            allowClear:true,
            disabled:false,
            width:'260px',
            optionToLocale:true,
            options:[
                {
                    label:'order.shiped',
                    value:3,
                },
            ]
        },
        {
            name:'stock.cargoFreight', // 运费
            key:'cargo_freight',
            type:'input',
            width:'260px',
            allowClear:true,
            prefix:true,
        },
    ]
}


ReissueQueryForm.formField.forEach(item=>{
    ReissueQueryForm.formData[item.key] = ''
})

ReissueEditForm.formField.forEach(item=>{
    ReissueEditForm.formData[item.key] = ''
})


export {
    ReissueQueryForm,
    ReissueEditForm,
}